import { render } from "./ModalModifierPriceSchedules.vue?vue&type=template&id=0e78ddd0&scoped=true"
import script from "./ModalModifierPriceSchedules.vue?vue&type=script&lang=js"
export * from "./ModalModifierPriceSchedules.vue?vue&type=script&lang=js"

import "./ModalModifierPriceSchedules.vue?vue&type=style&index=0&id=0e78ddd0&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e78ddd0"]])

export default __exports__